import { format } from "date-fns";

export const exportFileName = ({ startDate, endDate }) => {
  let dates = `${format(startDate, "MM/dd/yyyy")}_${format(endDate, "MM/dd/yyyy")}`;

  return `incident_reports_${dates}}`;
}

export const csvData = ({ incidentReports }) => {
  const headers = ['Incident Type', 'Location', 'Submitted By', 'Incident detail', 'Incident Date'];

  let data = [];
  
  incidentReports.map(incident => {
    let incidentData = [
      `${incident.incident_type}`,
      `${incident.property_name} ${incident.unit_number || ''}`,
      `${incident.submitted_by}`,
      `${incident.description}`,
      `${format(incident.incident_datetime, 'MM/dd/yyyy hh:mm')}`
    ];

    data.push(incidentData);
  })

  return [headers ?? []].concat(data);
}
